import { render } from "./B2bLoginPasswordFormPacsa.vue?vue&type=template&id=242a65bc&lang=pug"
import script from "./B2bLoginPasswordFormPacsa.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormPacsa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__